// eslint-disable-next-line no-restricted-imports
import API from 'app/gamma/src/api';
// eslint-disable-next-line no-restricted-imports
import { Action, actionCreator } from '@trello/redux';

// eslint-disable-next-line no-restricted-imports
import { BoardResponse, MemberResponse } from 'app/gamma/src/types/responses';
// eslint-disable-next-line no-restricted-imports
import { StandardThunkAction, Dispatch } from 'app/gamma/src/types';
import {
  BOARD_FIELDS,
  BOARD_FIELDS_MINIMAL,
  TEAM_FIELDS_MINIMAL,
} from './fields';
// eslint-disable-next-line no-restricted-imports
import { boardsMenuState } from 'app/gamma/src/modules/state/ui/boards-menu-state';

// eslint-disable-next-line no-restricted-imports
import { getMissingBoardIds } from 'app/gamma/src/selectors/boards';
// eslint-disable-next-line no-restricted-imports
import { State } from 'app/gamma/src/modules/types';

// Action types
export const LOAD_MY_BOARDS_SUCCESS = Symbol('loaders/LOAD_MY_BOARDS_SUCCESS');
export const LOAD_MISSING_BOARDS_SUCCESS = Symbol(
  'loaders/LOAD_MISSING_BOARD_SUCCESS',
);

export type LoadMyBoardsSuccessAction = Action<
  typeof LOAD_MY_BOARDS_SUCCESS,
  MemberResponse
>;

export type LoadMissingBoardsSuccessAction = Action<
  typeof LOAD_MISSING_BOARDS_SUCCESS,
  BoardResponse[]
>;

// Action creators
const loadMyBoardsSuccess = actionCreator<LoadMyBoardsSuccessAction>(
  LOAD_MY_BOARDS_SUCCESS,
);

const loadMissingBoardsSuccess = actionCreator<LoadMissingBoardsSuccessAction>(
  LOAD_MISSING_BOARDS_SUCCESS,
);

export const loadBoardsForSearch = (): StandardThunkAction => {
  return async (dispatch: Dispatch, getState: () => State) => {
    try {
      boardsMenuState.setValue({ ...boardsMenuState.value, loading: true });

      const me = await API.client.rest.get<MemberResponse>('members/me', {
        query: {
          boards: 'open,starred',
          board_fields: BOARD_FIELDS_MINIMAL,
          boardStars: true,
          organizations: 'all',
          organization_fields: TEAM_FIELDS_MINIMAL,
          board_organization: true,
          board_organization_fields: TEAM_FIELDS_MINIMAL,
          board_memberships: 'me',
        },
        headers: { 'X-Trello-Operation-Name': 'loadBoardsForSearch' },
      });

      boardsMenuState.setValue({ ...boardsMenuState.value, loading: false });
      dispatch(loadMyBoardsSuccess(me));
    } catch (err) {
      boardsMenuState.setValue({ ...boardsMenuState.value, loading: false });
    }

    const missingIds = getMissingBoardIds(getState(), boardsMenuState.value);

    try {
      const missingBoards = await Promise.all(
        missingIds.map((boardId: string) => {
          return API.client.rest.get<BoardResponse>(`boards/${boardId}`, {
            query: {
              fields: BOARD_FIELDS,
            },
            headers: {
              'X-Trello-Operation-Name': 'loadBoardsForSearch:missing',
            },
          });
        }),
      );

      dispatch(loadMissingBoardsSuccess(missingBoards));
    } catch (err) {
      // no-op
    }
  };
};
